import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "popup_close",
  "use": "popup_close-usage",
  "viewBox": "0 0 17.56 17.532",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 17.56 17.532\" id=\"popup_close\"><path d=\"m10.194 8.763 7.071 7.07a.999.999 0 1 1-1.414 1.414l-7.071-7.07-7.071 7.07a.999.999 0 1 1-1.414-1.414l7.071-7.07L.295 1.694A.999.999 0 1 1 1.709.28L8.78 7.35 15.851.28a1 1 0 0 1 1.414 1.414l-7.071 7.069Z\" style=\"fill:#e4e4e4;fill-rule:evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol